import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist<{
    isAuth: boolean;
    setIsAuth: (auth: boolean) => void;
  }>(
    (set) => ({
      isAuth: false,
      setIsAuth: (auth: boolean) => set({ isAuth: auth }),
    }),
    {
      name: "auth",
    },
  ),
);
